/**
 * @prettier
 */
export function toMinutes(duration?: number): number {
    if (!duration) return 0;
    return Math.ceil(duration / 60);
}
